import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../state'
import * as platform from '../platform'

import { EagerlyLoadedState } from './eagerly-loaded-state'

/**
 * Entry point for the entire application
 */
@ngCore.Component({
  imports: [ds.splashScreen.Component, platform.Component],
  selector: 'app-root',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /**
   * NOTE: very important!!
   *
   * @see {@link EagerlyLoadedState}
   */
  private readonly _eagerlyLoadedState = ngCore.inject(EagerlyLoadedState)
}
